"use client";

import { useState } from "react";

export type DemoDecision = "confirm" | "query" | "intentional" | "dismiss";

/** Local-only example: no manuscript upload, model call, or saved editorial decision. */
export function EditorDecisionDemo({
  initialDecision,
  decisions,
  label,
  disclaimer,
}: {
  initialDecision: DemoDecision;
  decisions: { key: DemoDecision; label: string; detail: string; result: string }[];
  label: string;
  disclaimer: string;
}) {
  const [selected, setSelected] = useState(initialDecision);
  return (
    <div className="mt-5">
      <div role="group" aria-label={label} className="grid gap-2 sm:grid-cols-2">
        {decisions.map((decision) => (
          <button
            key={decision.key}
            type="button"
            aria-pressed={selected === decision.key}
            onClick={() => setSelected(decision.key)}
            data-editor-cta={`demo-${decision.key}`}
            data-editor-cta-location="evidence-demo"
            className={`block min-h-12 w-full rounded-xl border px-3 py-2.5 text-start transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${selected === decision.key ? "border-[#2563eb] bg-[#2563eb] text-white" : "border-border bg-background hover:border-accent"}`}
          >
            <span className="block text-sm font-medium">{decision.label}</span>
            <span className={`mt-0.5 block text-xs ${selected === decision.key ? "text-white" : "text-muted-foreground"}`}>{decision.detail}</span>
          </button>
        ))}
      </div>
      <p role="status" aria-live="polite" aria-atomic="true" className="mt-4 text-sm leading-6">
        {decisions.find((decision) => decision.key === selected)?.result}
      </p>
      <p className="mt-3 text-xs leading-5 text-muted-foreground">{disclaimer}</p>
    </div>
  );
}
